// extracted by mini-css-extract-plugin
export default {"signup-prompt":"yc1lA_p4gXxTL2QXDZEF"};